import { render, staticRenderFns } from "./VehicleLanguage.vue?vue&type=template&id=4e6b511d&scoped=true"
import script from "./VehicleLanguage.vue?vue&type=script&lang=ts"
export * from "./VehicleLanguage.vue?vue&type=script&lang=ts"
import style0 from "./VehicleLanguage.vue?vue&type=style&index=0&id=4e6b511d&prod&scoped=true&lang=css"
import style1 from "./VehicleLanguage.vue?vue&type=style&index=1&id=4e6b511d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b511d",
  null
  
)

export default component.exports